var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item?.update)?_c('d-text-field',{staticClass:"label-text",attrs:{"size":"sm"},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}):_c('span',[_vm._v(" "+_vm._s(_vm.item.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }